import { ZxcvbnFactory } from '@zxcvbn-ts/core';
import { dictionary as commonDictionary, adjacencyGraphs } from '@zxcvbn-ts/language-common';
import { dictionary as enDictionary, translations } from '@zxcvbn-ts/language-en';

const zxcvbnInstance = new ZxcvbnFactory({
  dictionary: {
    ...commonDictionary,
    ...enDictionary,
  },
  graphs: adjacencyGraphs,
  translations,
  maxLength: 64,
});

export const PASSWORD_STRENGTH_LABELS = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong'];

// zxcvbn's score is 0-4
export const getPasswordStrength = (password, userInputs = []) =>
  password ? zxcvbnInstance.check(password, userInputs) : null;
